import { ADMIN, MANAGER, REPORT } from '../../../../../constants/selfAccounts'

export const EMAIL = 'email'
export const ROLE = 'role'

export const roleOptions = [
  {
    value: REPORT,
    label: 'Reporting only'
  },
  {
    value: MANAGER,
    label: 'Campaign manager'
  },
  {
    value: ADMIN,
    label: 'Admin'
  }
]

export const initialValues = {
  [EMAIL]: '',
  [ROLE]: ADMIN
}
